
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import UserPanel from './views/UserPanel/index.vue'
import ProgressCourse from './views/ProgressCourse/index.vue'
import StudyRecord from './views/StudyRecord/index.vue'
import ContentList from './views/ContentList/index.vue'
import UserContentPop from '@xt/www/components/classhour/pop-content/index.vue'
import type { HomeworkOption, DairyOption } from '@xt/client/entities/course-v2/user-content'
import { Observer } from 'mobx-vue'
import { CommonStudyCardUIData } from '@xt/client/entities/my-v2/types'
import { EnumMyCenterPrivacyConfig } from '@xt/client/enums/my'
import lodash from 'lodash'
import { Route } from 'vue-router'

@Observer
@Component({
  scrollToTop: true,
  components: {
    UserPanel,
    ProgressCourse,
    StudyRecord,
    ContentList,
    UserContentPop
  },
  async asyncData(ctx) {
    const isSelfVisit = ctx.store.$storeUser.UserInfo.id === ctx.query.memberId
    const res = await ctx.store.$myV2.Center.initPageData(ctx.query.memberId as string, isSelfVisit)

    if (!res) {
      ctx.redirect('/')
    }
  },
  validate({ query }) {
    const memberId = query.memberId
    return !!memberId && /^\d+$/.test(String(memberId))
  }
})
export default class UserCenterPage extends Vue {
  @Ref()
  userContentPop: {
    showPop: (options: HomeworkOption | DairyOption) => void
    hidePop: () => void
  }

  memberId: string = lodash.get(this.$route, 'query.memberId', '') as string

  get EnumMyCenterPrivacyConfig() {
    return EnumMyCenterPrivacyConfig
  }

  get isSelfVisit() {
    return this.memberId === this.$store.$storeUser.UserInfo.id
  }

  get PageStore() {
    return this.$store.$myV2.Center
  }

  // 此处作品也直接走日常详情类型进行展示, 极少数情况投票中的如果momentId为空, 则不处理
  async handleClickCard(data: CommonStudyCardUIData) {
    switch (data.type) {
      case 'dairy':
        this.userContentPop?.showPop({ type: 'dairy', momentId: `${data.id}` })
        return
      case 'collect':
        if (data.jumpType === 'show' || !data.id) return
        this.userContentPop?.showPop({ type: 'dairy', momentId: `${data.id}` })
        return
    }
  }

  handleLikeInCard(item: CommonStudyCardUIData) {
    this.PageStore.onLike(item)
  }

  // 弹窗外部回显状态处理
  handleFollowInContentPop(data: boolean) {
    this.PageStore.updateFollowData(data)
  }

  handleLikeInContentPop({ momentId }: { momentId: string }) {
    const item = this.PageStore.pagePagination.dataSource.find(i => i.id === momentId)

    if (item) {
      this.PageStore.onChangeLikeStatus(item, 'like')
    }
  }

  handleRemoveInContentPop(data: { type: 'homework'; homeworkId: number } | { type: 'dairy'; momentId: string }) {
    this.PageStore.onRemoveItem(data.type === 'dairy' ? data.momentId : data.homeworkId)

    if (data.type === 'homework') {
      this.userContentPop?.hidePop()
    }
  }

  @Watch('$route', { deep: true })
  onRouteChange(val: Route) {
    location.reload()
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
